import { DatePicker, FormLabel, Heading } from "@/components";
import usePayment360Report from "./useAR360Report";
import { Button } from "@/components/ui";
import { DetailedReport } from "./DetailedReport";
import { PropertyReport } from "./PropertyReport";

const AR360Report = () => {
  const { breadcrumbData, togglePropertyView, setDate, date, isPropertyView, currentFinanceYear } =
    usePayment360Report();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6 sticky top-[55px] z-10 bg-g-10 pb-3">
        <div className="flex flex-row items-center justify-between">
          <Heading title={<span>Collection 360 Report <span className="text-[12px]">(FY-{currentFinanceYear})</span></span>} breadcrumbData={breadcrumbData} />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px] items-center">
          <Button onClick={togglePropertyView} className="md:w-[300px]">
            {isPropertyView
              ? "View Detailed Report"
              : "View Detailed Report By Property"}
          </Button>
          <div className="relative">
            <FormLabel>Date</FormLabel>
            <DatePicker
              setDate={setDate}
              date={date}
              onClear={() => setDate(null)}
            />
          </div>
        </div>
      </div>

      {/* Data section */}
      {isPropertyView ? (
        <PropertyReport reportDate={date} />
      ) : (
        <DetailedReport reportDate={date} />
      )}
    </div>
  );
};

export default AR360Report;
